const CLIENT_PORTAL_INVOICE_REQUEST_RE =
	/requested invoice #([^\s]+)\s+status change/i;
const CLIENT_PORTAL_INVOICE_PATH_RE = /^\/client\/invoices\/([a-f\d]{24})$/i;
const INVOICE_VIEW_PATH_RE = /^\/invoice\/view\/([a-f\d]{24})$/i;

const normalizePath = (path) => {
	if (!path || typeof path !== 'string') return null;
	const trimmed = path.trim();
	if (!trimmed) return null;
	return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
};

/**
 * Resolve where a header notification "View" action should navigate.
 */
export const getNotificationTargetPath = (notification) => {
	const link = normalizePath(notification?.link);
	if (link) {
		const clientInvoiceMatch = link.match(CLIENT_PORTAL_INVOICE_PATH_RE);
		if (clientInvoiceMatch?.[1]) {
			return `/invoice/view/${clientInvoiceMatch[1]}`;
		}
		return link;
	}

	const invoiceId = notification?.meta?.invoiceId;
	if (invoiceId) {
		return `/invoice/view/${invoiceId}`;
	}

	const message = notification?.message || '';
	const invoiceMatch = message.match(CLIENT_PORTAL_INVOICE_REQUEST_RE);
	if (invoiceMatch?.[1] && notification?.type === 'client_portal') {
		// Backend enriches legacy rows; this is a last-resort fallback only.
		return null;
	}

	return null;
};

export const canNavigateToNotification = (notification) =>
	Boolean(getNotificationTargetPath(notification));
